import { IEntity } from '../../../../shared/interfaces/entity.interface';
import { EEntity } from '../../enums/entity.enum';
import { ESessionTemplate } from '../../enums/v2/session-template.enum';
import { IParticipantEntityApi } from '../api/participant-entity.interface';

export const directionCreateSession = {
  FROM: false,
  TO: true,
};

export interface ICreateSession {
  templateName: ESessionTemplate;
  templateParameters?: Record<string, string>;
}

export interface IDirectionItem {
  id: string;
  name: string;
  entityType: EEntity;
}

export interface ICallTemplateData {
  subject: string;
  phonenumber: string;
  to?: IDirectionItem[];
  from?: IDirectionItem[];
  directioncode?: boolean;
}

export interface IChatTemplateData {
  subject: string;
  solgari_channelprovider: string;
  solgari_fromraw: string;
  solgari_solgarconversationid: string;
  solgari_toraw: string;

  solgari_chat_activity_parties: Array<IParticipantEntityApi>;
}

export interface IChatPayload {
  source: string;
  user: IEntity;
  identity: string;
}
